import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpArgumentOperandFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpArgumentOperandRestrictionFactory } from "./ExpArgumentOperandRestriction";
// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";
// @ts-ignore noUnusedLocals
import { ExpArgumentOperandDependencyFactory } from "./ExpArgumentOperandDependency";
// @ts-ignore noUnusedLocals
import { ExpOperatorSummaryFormatFactory } from "./ExpOperatorSummaryFormat";

/**
 * 
 * @export
 * @interface ExpArgumentOperand
 */

export class ExpArgumentOperandFactory {}

/**
* @export
* @enum {string}
*/
_ExpArgumentOperandFactory = ExpArgumentOperandFactory;
_defineProperty(ExpArgumentOperandFactory, "FromJSON", function (json) {
  return _ExpArgumentOperandFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpArgumentOperandFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'name': json['name'],
    'label': json['label'],
    'labelPlacement': json['labelPlacement'],
    'selectorLabel': json['selectorLabel'],
    'description': json['description'],
    'categoryID': json['categoryID'],
    'categoryLabelAlias': json['categoryLabelAlias'],
    'valueTypeID': json['valueTypeID'],
    'expandToAllDefaultCategories': json['expandToAllDefaultCategories'],
    'optional': json['optional'],
    'multiple': json['multiple'],
    'groupID': json['groupID'],
    'inputPromptText': json['inputPromptText'],
    'noOperatorInput': json['noOperatorInput'],
    'noFormulaInput': json['noFormulaInput'],
    'subExpressionIterates': json['subExpressionIterates'],
    'numDecimalPlaces': json['numDecimalPlaces'],
    'defaultCategoryID': json['defaultCategoryID'],
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'advanced': json['advanced'],
    'restrictions': json['restrictions'] === null || json['restrictions'] === undefined ? json['restrictions'] : json['restrictions'].map(ExpArgumentOperandRestrictionFactory.FromJSON),
    'editorConfiguration': json['editorConfiguration'] === null || json['editorConfiguration'] === undefined ? json['editorConfiguration'] : json['editorConfiguration'],
    'summaryOutputFormats': json['summaryOutputFormats'] === null || json['summaryOutputFormats'] === undefined ? json['summaryOutputFormats'] : json['summaryOutputFormats'].map(ExpOperatorSummaryFormatFactory.FromJSON),
    'executionFlags': json['executionFlags'] === null || json['executionFlags'] === undefined ? json['executionFlags'] : json['executionFlags'],
    'onlyOperatorInput': json['onlyOperatorInput'],
    'dependencies': json['dependencies'] === null || json['dependencies'] === undefined ? json['dependencies'] : json['dependencies'].map(ExpArgumentOperandDependencyFactory.FromJSON)
  };
});
_defineProperty(ExpArgumentOperandFactory, "ToJSON", function (value) {
  return _ExpArgumentOperandFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpArgumentOperandFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'name': value.name,
    'label': value.label,
    'labelPlacement': value.labelPlacement,
    'selectorLabel': value.selectorLabel,
    'description': value.description,
    'categoryID': value.categoryID,
    'categoryLabelAlias': value.categoryLabelAlias,
    'valueTypeID': value.valueTypeID,
    'expandToAllDefaultCategories': value.expandToAllDefaultCategories,
    'optional': value.optional,
    'multiple': value.multiple,
    'groupID': value.groupID,
    'inputPromptText': value.inputPromptText,
    'noOperatorInput': value.noOperatorInput,
    'noFormulaInput': value.noFormulaInput,
    'subExpressionIterates': value.subExpressionIterates,
    'numDecimalPlaces': value.numDecimalPlaces,
    'defaultCategoryID': value.defaultCategoryID,
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'advanced': value.advanced,
    'restrictions': value.restrictions === undefined ? undefined : value.restrictions.map(ExpArgumentOperandRestrictionFactory.ToJSON),
    'editorConfiguration': value.editorConfiguration,
    'summaryOutputFormats': value.summaryOutputFormats === undefined ? undefined : value.summaryOutputFormats.map(ExpOperatorSummaryFormatFactory.ToJSON),
    'executionFlags': value.executionFlags,
    'onlyOperatorInput': value.onlyOperatorInput,
    'dependencies': value.dependencies === undefined ? undefined : value.dependencies.map(ExpArgumentOperandDependencyFactory.ToJSON)
  };
});
export let ExpArgumentOperandLabelPlacementEnum = /*#__PURE__*/function (ExpArgumentOperandLabelPlacementEnum) {
  ExpArgumentOperandLabelPlacementEnum["PREFIX"] = "PREFIX";
  ExpArgumentOperandLabelPlacementEnum["SUFFIX"] = "SUFFIX";
  return ExpArgumentOperandLabelPlacementEnum;
}({});
//# sourceMappingURL=ExpArgumentOperand.js.map
